document.addEventListener('DOMContentLoaded', function () {
    var splide = new Splide('.related-recipe__splide', {
      type: 'slide',
      perPage: 3,
      perMove: 1,
      arrows: false,
      pagination: true,
      breakpoints: {
        768: {
          perPage: 3,
        },
        480: {
          perPage: 2,
        },
      },
    });
    splide.mount();
  });